<div *ngIf="agent">
  <lms-breadcrumb [label]="agent.fullName || agent.email"></lms-breadcrumb>

  <mat-tab-group
    class="tab-group"
    #tabGroup
    animationDuration="0ms"
    disableRipple="true"
    (selectedTabChange)="tabsManager.setTab($event)"
  >
    <mat-tab label="data">
      <ng-template mat-tab-label>{{ 'nouns.data' | translate }}</ng-template>
      <ng-template matTabContent>
        <lms-agent-editor [agent]="agent" (onSave)="onUpdateAgent($event)"> </lms-agent-editor>
      </ng-template>
    </mat-tab>
    <mat-tab label="clients" *ngIf="config.clients">
      <ng-template mat-tab-label>{{ 'clients.label' | translate }}</ng-template>
      <ng-template matTabContent>
        <lms-toolbar>
          <lms-search-field [listId]="agentClientslistId"></lms-search-field>
          <lms-items-count-selector
            class="hide-on-med-and-down"
            [listId]="agentClientslistId"
          ></lms-items-count-selector>
          <div class="lms-toolbar__item">
            <lms-print></lms-print>
            <gl-button
              color-primary
              title="{{ 'clients.create' | translate }}"
              [text]="'clients.create' | translate"
              [routerLink]="['/clients/new']"
              *lmsProfileGuard="'clients.create'"
            ></gl-button>
          </div>
        </lms-toolbar>
        <lms-clients-list [listId]="agentClientslistId" [options]="{ filters: filters }"></lms-clients-list>
      </ng-template>
    </mat-tab>
    <mat-tab label="classes" *ngIf="config.groups">
      <ng-template mat-tab-label>{{ 'agents.tabs.groups' | translate }}</ng-template>
      <ng-template matTabContent>
        <lms-toolbar
          [options]="{ list: { listId: agentGroupslistId, download: true, filterRow: true, skeletor: true } }"
        >
          <div class="lms-toolbar__item" *lmsProfileGuard="'groups.create'" tools-actions>
            <gl-button
              color-primary
              [text]="'groups.add' | translate"
              [routerLink]="['/groups/new']"
              title="{{ 'groups.create' | translate }}"
            >
            </gl-button>
          </div>
        </lms-toolbar>

        <lms-groups-list
          [listId]="agentGroupslistId"
          [options]="{ filters: { agentIds: agent.id }, sort: 'endDate' }"
        ></lms-groups-list>
      </ng-template>
    </mat-tab>
    <mat-tab label="emails">
      <ng-template mat-tab-label>{{ 'emails.label' | translate }}</ng-template>
      <ng-template matTabContent>
        <lms-toolbar
          [options]="{ list: { listId: agentEmailsListId, download: true, filterRow: false, skeletor: true } }"
        ></lms-toolbar>
        <lms-emails-list #emails [listId]="agentEmailsListId" [options]="{ filters: filters, timezone: timezone }">
        </lms-emails-list>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <div class="gl-context-menu__position">
    <lms-button-actions>
      <div class="gl-context-menu__options">
        <span
          class="gl-context-menu__options--item"
          *lmsProfileGuard="'agents.transferAccounts'"
          (click)="modalAgentsSelector.open()"
          title="{{ 'actions.transferAgentAccounts' | translate }}"
          tools-actions
        >
          {{ 'agents.transfer' | translate }}
        </span>
        <span
          class="gl-context-menu__options--item"
          *lmsProfileGuard="'students.change-role'"
          (click)="modalAdminRoleChanger.open()"
          title="{{ 'actions.changeUserRole' | translate }}"
        >
          {{ 'actions.changeUserRole' | translate }}
        </span>
        <span
          class="gl-context-menu__options--item alert"
          *lmsProfileGuard="'agents.delete'"
          title="{{ 'agents.delete' | translate }}"
          (click)="agent.role !== 'superAdmin' ? deleteAgent() : noDeleteAgent()"
          >{{ 'agents.delete' | translate }}</span
        >
      </div>
    </lms-button-actions>
  </div>
  <lms-admin-role-changer
    #modalAdminRoleChanger
    [user]="agent"
    (roleChanged)="onUpdateAgent($event)"
  ></lms-admin-role-changer>
  <lms-transfer-agent-accounts #modalAgentsSelector [agent]="agent"></lms-transfer-agent-accounts>
</div>
